// Server domain address

const config = {
  URI: 'https://webrtc-dev1.freshvoice.asia',
  VIDEO_URL: 'https://video-dev.workshop-live.com',
  ADMIN_URL: 'https://admin-dev.workshop-live.com',
  STRIPE_KEY: 'pk_test_tJH061vmw8dDCltqx13QBVat',
  PREMIUM: 'plan_DFNbHaA3qgtAPm',
  FREE: 'plan_DFRJJ7pJpUmRSc',
  PLANS: {
    free: 'Free',
    free_admin: 'Free',
    free_guest: 'Free',
    guest: 'Free',
    starter_month: 'Starter monthly',
    starter_year: 'Starter yearly',
    premium_month: 'Premium monthly',
    premium_year: 'Premium yearly'
  },
  FVlite_DEBUG: true,
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyDsddDaw6PK6UO_Ht8m5Blq5uTrAHnPOO8",
    authDomain: "workshop-video-prod.firebaseapp.com",
    databaseURL: "https://workshop-video-prod.firebaseio.com",
    projectId: "workshop-video-prod",
    storageBucket: "workshop-video-prod.appspot.com",
    messagingSenderId: "447629060783"
  },
  SENTRY: "https://2eea8dd1a27846ab948925e1ddf65881@sentry.io/1477150",
  GIT_HASH: "f4dda8a",
  GIT_BRANCH: "master"
};


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js